import {
  UTM_CAMPAIGN_QUERY_PARAM_KEY,
  UTM_MEDIUM_EMAIL,
  UTM_MEDIUM_QUERY_PARAM_KEY,
  UTM_SOURCE_COMMAND_LINK,
  UTM_SOURCE_QUERY_PARAM_KEY,
} from "../../constants";

import type { CommandLinkUtmCampaign } from "../../constants";

/**
 * Tags the link so product can attribute the in-app session that follows to the
 * command link, separately from the on-landing analytics events
 * (docs/engineering/design/carrier_submit_quote_command_link_design.md §8).
 */
export function buildShipmentDetailUrlWithCommandLinkUtm(
  shipmentId: number,
  campaign: CommandLinkUtmCampaign,
): string {
  const utmParams = new URLSearchParams({
    [UTM_SOURCE_QUERY_PARAM_KEY]: UTM_SOURCE_COMMAND_LINK,
    [UTM_MEDIUM_QUERY_PARAM_KEY]: UTM_MEDIUM_EMAIL,
    [UTM_CAMPAIGN_QUERY_PARAM_KEY]: campaign,
  });
  return `/shipments/${shipmentId}?${utmParams}`;
}
